// extracted by mini-css-extract-plugin
export default {"cardMenuIcon":"CardMenu_cardMenuIcon__qF0e4"};